<script lang="ts">
export default {
  name: 'KkProgressBar',
}
</script>

<script lang="ts" setup>
import { computed, defineProps } from 'vue'

export interface Props {
  denominator: number
  currentCount: number
}

const props = defineProps<Props>()

// 進捗バーの幅を計算
const progressWidth = computed(() => {
  const width = (props.currentCount / props.denominator) * 100
  return width > 100 ? 100 : width // 進捗率が100%を超えないように調整
})

// 進捗バーの色を計算
const progressBarColor = computed(() => {
  if (props.currentCount > props.denominator) {
    return '#E9446A' // 100%を超えた時
  }
  return '#4C959A' // それ以外の通常の状態
})

// スタイルオブジェクトを算出プロパティとして定義
const barStyle = computed(() => ({
  width: progressWidth.value + '%',
  backgroundColor: progressBarColor.value,
}))
</script>
<template>
  <div
    :aria-valuenow="progressWidth"
    aria-valuemin="0"
    aria-valuemax="100"
    role="progressbar"
    class="progress-container"
  >
    <div class="progress-bar" :style="barStyle" />
  </div>
</template>

<style lang="scss" scoped>
.progress-container {
  flex-grow: 1;
  height: 8px;
  border-radius: 4px;
  overflow: hidden;
  background-color: #E4E7EB;
}
.progress-bar {
  height: 100%;
  transition: width .3s ease;
}
</style>
